import TemplateView from '../../../../TemplateView'
import {MONTH_LICENSES_DURATION, purchaseStep, purchaseStrategyType} from '../../constants'
import PaymentContent from './paymentStep/PaymentContent'
import EnterCompanyInfoStep from './EnterCompanyInfoStep'
import ConfigureAccountInfoStep from './accountInfo/ConfigureAccountInfoStep'
import OrderSummary from './orderSummary/OrderSummary'
import messageResource from '../../../../messageResource'
import SuccessContent from './successStep/SuccessContent'
import FreeOrderSummary from './orderSummary/FreeOrderSummary'
import {bindActionCreators} from 'redux'
import {connect} from '../../../../redux/utils'
import {getEndDate, getPurchasePeriod, getStartDate, getUsersCount, isSelectUnlimitedUsers} from '../chooser/selectors'
import {
    getCurrentLicenceEndDate,
    getCurrentLicenceStartDate,
    getCurrentlyLicencedUsersCount,
    getUsersCount as getUsersCountToAdd,
    isSelectUnlimitedUsers as isUnlimitedSelectedToAdd
} from '../licenseList/addUsers/selectors'
import {preparePaymentStep} from './actions'

class PurchaseLightBoxContent extends TemplateView {
    constructor({
        preparePaymentStep = () => {},
    }) {
        super()

        this.state = {
            purchaseStep: purchaseStep.COMPANY_INFO,
            purchaseStrategyType: '',

            purchasePeriod: 0,
            startDate: new Date(),
            endDate: new Date(),
            unlimited: false,
            usersCount: 0,

            usersCountToAdd: 0,
            unlimitedSelectedToAdd: false,
            currentUsersCount: 0,
            startDateToAdd: new Date(),
            endDateToAdd: new Date(),
        }

        this.actions = {
            preparePaymentStep: preparePaymentStep,
        }

        this.onStatePropertyChanged('purchaseStep', (step) => {
            if (step === purchaseStep.PAYMENT) {
                this.actions.preparePaymentStep()
            }

            this.$companyInfo.toggle(step === purchaseStep.COMPANY_INFO)
            this.$accountInfo.toggle(step === purchaseStep.ACCOUNT_INFO)
            this.$payment.toggle(step === purchaseStep.PAYMENT)
            this.$success.toggle(step === purchaseStep.SUCCESS)
            this.$order.toggle(step !== purchaseStep.SUCCESS)
        })
        this.onStatePropertyChanged('purchaseStrategyType', (strategyType) => {
            this.$paidOrder.toggle(strategyType !== purchaseStrategyType.FIRST_FREE)
            this.$freeOrder.toggle(strategyType === purchaseStrategyType.FIRST_FREE)
        })

        this.onAnyStatePropertyChanged([
            'purchaseStrategyType', 'purchasePeriod', 'unlimited', 'usersCount',
            'usersCountToAdd', 'unlimitedSelectedToAdd', 'currentUsersCount'
        ], () => {
            this.orderSummary.setState(this._getUserDescriptionTexts())
        })

        this.onAnyStatePropertyChanged(['purchaseStrategyType', 'startDate', 'endDate', 'startDateToAdd', 'endDateToAdd'], () => {
            const addUsers = this.state.purchaseStrategyType === purchaseStrategyType.ADD_USERS
            this.orderSummary.setState({
                startDate: addUsers ? this.state.startDateToAdd : this.state.startDate,
                endDate: addUsers ? this.state.endDateToAdd : this.state.endDate,
            })
        })
    }

    templateHtml() {
        return '<div class="content">' +
               '    <div class="companyInfo"/>' +
               '    <div class="accountInfo"/>' +
               '    <div class="payment"/>' +
               '    <div class="success"/>' +
               '    <div class="order">' +
               '        <div class="paid"/>' +
               '        <div class="free"/>' +
               '    </div>' +
               '</div>'
    }

    afterRender() {
        this.$companyInfo = this.find('.companyInfo')
        this.$accountInfo = this.find('.accountInfo')
        this.$success = this.find('.success')
        this.$payment = this.find('.payment')

        this.payment = new PaymentContent().init(this.$payment)
        this.companyInfo = new EnterCompanyInfoStep().init(this.$companyInfo)
        this.accountInfo = new ConfigureAccountInfoStep().init(this.$accountInfo)
        this.success = new SuccessContent().init(this.$success)

        this.$order = this.find('.order')
        this.$paidOrder = this.find('.order .paid')
        this.$freeOrder = this.find('.order .free')

        this.orderSummary = new OrderSummary().init(this.$paidOrder)
        new FreeOrderSummary().init(this.$freeOrder)

        this.renderInitialState()
    }

    getStripeElements() {
        return this.payment.getStripeElements()
    }

    clearStripeElements() {
        return this.payment.clearStripeElements()
    }

    _getUserDescriptionTexts() {
        let summaryText
        let basePriceDescription
        let usersTotalText = ''

        if (this.state.purchaseStrategyType !== purchaseStrategyType.ADD_USERS) {
            const users = this.state.unlimited ? messageResource.getMessage('licenses.unlimited') : this.state.usersCount
            if (this.state.purchasePeriod === MONTH_LICENSES_DURATION) {
                summaryText = messageResource.getMessage('licenses.purchase_lightbox.check.users_for_month', [users])
                basePriceDescription = messageResource.getMessage('licenses.purchase_lightbox.check.users_for_month_price', [users])
            } else {
                summaryText = messageResource.getMessage('licenses.purchase_lightbox.check.users_for_year', [users])
                basePriceDescription = messageResource.getMessage('licenses.purchase_lightbox.check.users_for_year_price', [users])
            }
        } else {
            if (this.state.unlimitedSelectedToAdd) {
                summaryText = messageResource.getMessage('licenses.purchase_lightbox.check.switch_to_unlimited')
                basePriceDescription = messageResource.getMessage('licenses.switch_to_unlimited')
            } else {
                summaryText = messageResource.getMessage('licenses.purchase_lightbox.check.add_users', [this.state.usersCountToAdd])
                basePriceDescription = messageResource.getMessage('licenses.purchase_lightbox.check.add_users_price', [this.state.usersCountToAdd])
                usersTotalText = messageResource.getMessage('licenses.purchase_lightbox.check.add_users_total_users_count',
                    [this.state.currentUsersCount + this.state.usersCountToAdd])
            }
        }

        return {
            summaryText,
            basePriceDescription,
            usersTotalText,
        }
    }
}

export default connect(
    (state) => ({
        purchasePeriod: getPurchasePeriod(state),
        startDate: getStartDate(state),
        endDate: getEndDate(state),
        unlimited: isSelectUnlimitedUsers(state),
        usersCount: getUsersCount(state),
        usersCountToAdd: getUsersCountToAdd(state),
        unlimitedSelectedToAdd: isUnlimitedSelectedToAdd(state),
        currentUsersCount: getCurrentlyLicencedUsersCount(state),
        startDateToAdd: getCurrentLicenceStartDate(state),
        endDateToAdd: getCurrentLicenceEndDate(state),

    }),
    (dispatch) => ({
        preparePaymentStep: bindActionCreators(preparePaymentStep, dispatch),
    })
)(PurchaseLightBoxContent)



// WEBPACK FOOTER //
// ./web/js/administration/licenses/components/purchaseLightBox/PurchaseLightBoxContent.js